/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { BodyPostV2AddMarketplaceAgent } from "../../models/bodyPostV2AddMarketplaceAgent.ts";

import type { GetV2GetLibraryAgentByGraphIdParams } from "../../models/getV2GetLibraryAgentByGraphIdParams.ts";

import type { GetV2GetLibraryAgentsByIdsParams } from "../../models/getV2GetLibraryAgentsByIdsParams.ts";

import type { GetV2ListFavoriteLibraryAgentsParams } from "../../models/getV2ListFavoriteLibraryAgentsParams.ts";

import type { GetV2ListLibraryAgentsParams } from "../../models/getV2ListLibraryAgentsParams.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { LibraryAgent } from "../../models/libraryAgent.ts";

import type { LibraryAgentResponse } from "../../models/libraryAgentResponse.ts";

import type { LibraryAgentUpdateRequest } from "../../models/libraryAgentUpdateRequest.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getV2ListLibraryAgentsResponse200 = {
  data: LibraryAgentResponse;
  status: 200;
};

export type getV2ListLibraryAgentsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListLibraryAgentsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListLibraryAgentsResponseSuccess =
  getV2ListLibraryAgentsResponse200 & {
    headers: Headers;
  };
export type getV2ListLibraryAgentsResponseError = (
  | getV2ListLibraryAgentsResponse401
  | getV2ListLibraryAgentsResponse422
) & {
  headers: Headers;
};

export type getV2ListLibraryAgentsResponse =
  | getV2ListLibraryAgentsResponseSuccess
  | getV2ListLibraryAgentsResponseError;

export const getGetV2ListLibraryAgentsUrl = (
  params?: GetV2ListLibraryAgentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/library/agents?${stringifiedParams}`
    : `/api/library/agents`;
};

/**
 * Get all agents in the user's library (both created and saved).
 * @summary List Library Agents
 */
export const getV2ListLibraryAgents = async (
  params?: GetV2ListLibraryAgentsParams,
  options?: RequestInit,
): Promise<getV2ListLibraryAgentsResponse> => {
  return customMutator<getV2ListLibraryAgentsResponse>(
    getGetV2ListLibraryAgentsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListLibraryAgentsInfiniteQueryKey = (
  params?: GetV2ListLibraryAgentsParams,
) => {
  return [`/api/library/agents`, ...(params ? [params] : [])] as const;
};

export const getGetV2ListLibraryAgentsQueryKey = (
  params?: GetV2ListLibraryAgentsParams,
) => {
  return [`/api/library/agents`, ...(params ? [params] : [])] as const;
};

export const getGetV2ListLibraryAgentsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
    GetV2ListLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListLibraryAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListLibraryAgentsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
    QueryKey,
    GetV2ListLibraryAgentsParams["page"]
  > = ({ signal, pageParam }) =>
    getV2ListLibraryAgents(
      { ...params, page: pageParam ?? params?.["page"] },
      { signal, ...requestOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
    TError,
    TData,
    QueryKey,
    GetV2ListLibraryAgentsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListLibraryAgentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListLibraryAgents>>
>;
export type GetV2ListLibraryAgentsInfiniteQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListLibraryAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
    GetV2ListLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListLibraryAgentsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListLibraryAgentsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListLibraryAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
    GetV2ListLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListLibraryAgentsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListLibraryAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
    GetV2ListLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListLibraryAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Library Agents
 */

export function useGetV2ListLibraryAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
    GetV2ListLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListLibraryAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListLibraryAgentsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Library Agents
 */
export const prefetchGetV2ListLibraryAgentsInfiniteQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListLibraryAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListLibraryAgentsInfiniteQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getGetV2ListLibraryAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListLibraryAgentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListLibraryAgents>>
  > = ({ signal }) =>
    getV2ListLibraryAgents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListLibraryAgentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListLibraryAgents>>
>;
export type GetV2ListLibraryAgentsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListLibraryAgents<
  TData = Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListLibraryAgentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListLibraryAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListLibraryAgents<
  TData = Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListLibraryAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListLibraryAgents<
  TData = Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Library Agents
 */

export function useGetV2ListLibraryAgents<
  TData = Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListLibraryAgentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Library Agents
 */
export const prefetchGetV2ListLibraryAgentsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLibraryAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListLibraryAgentsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2AddMarketplaceAgentResponse201 = {
  data: LibraryAgent;
  status: 201;
};

export type postV2AddMarketplaceAgentResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2AddMarketplaceAgentResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2AddMarketplaceAgentResponseSuccess =
  postV2AddMarketplaceAgentResponse201 & {
    headers: Headers;
  };
export type postV2AddMarketplaceAgentResponseError = (
  | postV2AddMarketplaceAgentResponse401
  | postV2AddMarketplaceAgentResponse422
) & {
  headers: Headers;
};

export type postV2AddMarketplaceAgentResponse =
  | postV2AddMarketplaceAgentResponseSuccess
  | postV2AddMarketplaceAgentResponseError;

export const getPostV2AddMarketplaceAgentUrl = () => {
  return `/api/library/agents`;
};

/**
 * Add an agent from the marketplace to the user's library.
 * @summary Add Marketplace Agent
 */
export const postV2AddMarketplaceAgent = async (
  bodyPostV2AddMarketplaceAgent: BodyPostV2AddMarketplaceAgent,
  options?: RequestInit,
): Promise<postV2AddMarketplaceAgentResponse> => {
  return customMutator<postV2AddMarketplaceAgentResponse>(
    getPostV2AddMarketplaceAgentUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bodyPostV2AddMarketplaceAgent),
    },
  );
};

export const getPostV2AddMarketplaceAgentMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2AddMarketplaceAgent>>,
    TError,
    { data: BodyPostV2AddMarketplaceAgent },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2AddMarketplaceAgent>>,
  TError,
  { data: BodyPostV2AddMarketplaceAgent },
  TContext
> => {
  const mutationKey = ["postV2AddMarketplaceAgent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2AddMarketplaceAgent>>,
    { data: BodyPostV2AddMarketplaceAgent }
  > = (props) => {
    const { data } = props ?? {};

    return postV2AddMarketplaceAgent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2AddMarketplaceAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2AddMarketplaceAgent>>
>;
export type PostV2AddMarketplaceAgentMutationBody =
  BodyPostV2AddMarketplaceAgent;
export type PostV2AddMarketplaceAgentMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Add Marketplace Agent
 */
export const usePostV2AddMarketplaceAgent = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2AddMarketplaceAgent>>,
      TError,
      { data: BodyPostV2AddMarketplaceAgent },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2AddMarketplaceAgent>>,
  TError,
  { data: BodyPostV2AddMarketplaceAgent },
  TContext
> => {
  return useMutation(
    getPostV2AddMarketplaceAgentMutationOptions(options),
    queryClient,
  );
};
export type getV2GetLibraryAgentsByIdsResponse200 = {
  data: LibraryAgent[];
  status: 200;
};

export type getV2GetLibraryAgentsByIdsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetLibraryAgentsByIdsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetLibraryAgentsByIdsResponseSuccess =
  getV2GetLibraryAgentsByIdsResponse200 & {
    headers: Headers;
  };
export type getV2GetLibraryAgentsByIdsResponseError = (
  | getV2GetLibraryAgentsByIdsResponse401
  | getV2GetLibraryAgentsByIdsResponse422
) & {
  headers: Headers;
};

export type getV2GetLibraryAgentsByIdsResponse =
  | getV2GetLibraryAgentsByIdsResponseSuccess
  | getV2GetLibraryAgentsByIdsResponseError;

export const getGetV2GetLibraryAgentsByIdsUrl = (
  params: GetV2GetLibraryAgentsByIdsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/library/agents/batch?${stringifiedParams}`
    : `/api/library/agents/batch`;
};

/**
 * Get several library agents at once, as `GET /agents/{id}` would return each.
 * @summary Get Library Agents By Ids
 */
export const getV2GetLibraryAgentsByIds = async (
  params: GetV2GetLibraryAgentsByIdsParams,
  options?: RequestInit,
): Promise<getV2GetLibraryAgentsByIdsResponse> => {
  return customMutator<getV2GetLibraryAgentsByIdsResponse>(
    getGetV2GetLibraryAgentsByIdsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetLibraryAgentsByIdsQueryKey = (
  params?: GetV2GetLibraryAgentsByIdsParams,
) => {
  return [`/api/library/agents/batch`, ...(params ? [params] : [])] as const;
};

export const getGetV2GetLibraryAgentsByIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetLibraryAgentsByIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetLibraryAgentsByIdsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>
  > = ({ signal }) =>
    getV2GetLibraryAgentsByIds(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetLibraryAgentsByIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>
>;
export type GetV2GetLibraryAgentsByIdsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetLibraryAgentsByIds<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetLibraryAgentsByIdsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
          TError,
          Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetLibraryAgentsByIds<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetLibraryAgentsByIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
          TError,
          Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetLibraryAgentsByIds<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetLibraryAgentsByIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Library Agents By Ids
 */

export function useGetV2GetLibraryAgentsByIds<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetLibraryAgentsByIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetLibraryAgentsByIdsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Library Agents By Ids
 */
export const prefetchGetV2GetLibraryAgentsByIdsQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params: GetV2GetLibraryAgentsByIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentsByIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetLibraryAgentsByIdsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetLibraryAgentByGraphIdResponse200 = {
  data: LibraryAgent;
  status: 200;
};

export type getV2GetLibraryAgentByGraphIdResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetLibraryAgentByGraphIdResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetLibraryAgentByGraphIdResponseSuccess =
  getV2GetLibraryAgentByGraphIdResponse200 & {
    headers: Headers;
  };
export type getV2GetLibraryAgentByGraphIdResponseError = (
  | getV2GetLibraryAgentByGraphIdResponse401
  | getV2GetLibraryAgentByGraphIdResponse422
) & {
  headers: Headers;
};

export type getV2GetLibraryAgentByGraphIdResponse =
  | getV2GetLibraryAgentByGraphIdResponseSuccess
  | getV2GetLibraryAgentByGraphIdResponseError;

export const getGetV2GetLibraryAgentByGraphIdUrl = (
  graphId: string,
  params?: GetV2GetLibraryAgentByGraphIdParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/library/agents/by-graph/${graphId}?${stringifiedParams}`
    : `/api/library/agents/by-graph/${graphId}`;
};

/**
 * @summary Get Library Agent By Graph Id
 */
export const getV2GetLibraryAgentByGraphId = async (
  graphId: string,
  params?: GetV2GetLibraryAgentByGraphIdParams,
  options?: RequestInit,
): Promise<getV2GetLibraryAgentByGraphIdResponse> => {
  return customMutator<getV2GetLibraryAgentByGraphIdResponse>(
    getGetV2GetLibraryAgentByGraphIdUrl(graphId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetLibraryAgentByGraphIdQueryKey = (
  graphId: string,
  params?: GetV2GetLibraryAgentByGraphIdParams,
) => {
  return [
    `/api/library/agents/by-graph/${graphId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetLibraryAgentByGraphIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV2GetLibraryAgentByGraphIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetLibraryAgentByGraphIdQueryKey(graphId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>
  > = ({ signal }) =>
    getV2GetLibraryAgentByGraphId(graphId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: graphId !== null && graphId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetLibraryAgentByGraphIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>
>;
export type GetV2GetLibraryAgentByGraphIdQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetLibraryAgentByGraphId<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params: undefined | GetV2GetLibraryAgentByGraphIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
          TError,
          Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetLibraryAgentByGraphId<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV2GetLibraryAgentByGraphIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
          TError,
          Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetLibraryAgentByGraphId<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV2GetLibraryAgentByGraphIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Library Agent By Graph Id
 */

export function useGetV2GetLibraryAgentByGraphId<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV2GetLibraryAgentByGraphIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetLibraryAgentByGraphIdQueryOptions(
    graphId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Library Agent By Graph Id
 */
export const prefetchGetV2GetLibraryAgentByGraphIdQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  graphId: string,
  params?: GetV2GetLibraryAgentByGraphIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgentByGraphId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetLibraryAgentByGraphIdQueryOptions(
    graphId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListFavoriteLibraryAgentsResponse200 = {
  data: LibraryAgentResponse;
  status: 200;
};

export type getV2ListFavoriteLibraryAgentsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListFavoriteLibraryAgentsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListFavoriteLibraryAgentsResponseSuccess =
  getV2ListFavoriteLibraryAgentsResponse200 & {
    headers: Headers;
  };
export type getV2ListFavoriteLibraryAgentsResponseError = (
  | getV2ListFavoriteLibraryAgentsResponse401
  | getV2ListFavoriteLibraryAgentsResponse422
) & {
  headers: Headers;
};

export type getV2ListFavoriteLibraryAgentsResponse =
  | getV2ListFavoriteLibraryAgentsResponseSuccess
  | getV2ListFavoriteLibraryAgentsResponseError;

export const getGetV2ListFavoriteLibraryAgentsUrl = (
  params?: GetV2ListFavoriteLibraryAgentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/library/agents/favorites?${stringifiedParams}`
    : `/api/library/agents/favorites`;
};

/**
 * Get all favorite agents in the user's library.
 * @summary List Favorite Library Agents
 */
export const getV2ListFavoriteLibraryAgents = async (
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: RequestInit,
): Promise<getV2ListFavoriteLibraryAgentsResponse> => {
  return customMutator<getV2ListFavoriteLibraryAgentsResponse>(
    getGetV2ListFavoriteLibraryAgentsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListFavoriteLibraryAgentsInfiniteQueryKey = (
  params?: GetV2ListFavoriteLibraryAgentsParams,
) => {
  return [
    `/api/library/agents/favorites`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListFavoriteLibraryAgentsQueryKey = (
  params?: GetV2ListFavoriteLibraryAgentsParams,
) => {
  return [
    `/api/library/agents/favorites`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListFavoriteLibraryAgentsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
    GetV2ListFavoriteLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListFavoriteLibraryAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ListFavoriteLibraryAgentsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
    QueryKey,
    GetV2ListFavoriteLibraryAgentsParams["page"]
  > = ({ signal, pageParam }) =>
    getV2ListFavoriteLibraryAgents(
      { ...params, page: pageParam ?? params?.["page"] },
      { signal, ...requestOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
    TError,
    TData,
    QueryKey,
    GetV2ListFavoriteLibraryAgentsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListFavoriteLibraryAgentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>
>;
export type GetV2ListFavoriteLibraryAgentsInfiniteQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListFavoriteLibraryAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
    GetV2ListFavoriteLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListFavoriteLibraryAgentsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListFavoriteLibraryAgentsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListFavoriteLibraryAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
    GetV2ListFavoriteLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListFavoriteLibraryAgentsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListFavoriteLibraryAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
    GetV2ListFavoriteLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListFavoriteLibraryAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Favorite Library Agents
 */

export function useGetV2ListFavoriteLibraryAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
    GetV2ListFavoriteLibraryAgentsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListFavoriteLibraryAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListFavoriteLibraryAgentsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Favorite Library Agents
 */
export const prefetchGetV2ListFavoriteLibraryAgentsInfiniteQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListFavoriteLibraryAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListFavoriteLibraryAgentsInfiniteQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getGetV2ListFavoriteLibraryAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListFavoriteLibraryAgentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>
  > = ({ signal }) =>
    getV2ListFavoriteLibraryAgents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListFavoriteLibraryAgentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>
>;
export type GetV2ListFavoriteLibraryAgentsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListFavoriteLibraryAgents<
  TData = Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListFavoriteLibraryAgentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListFavoriteLibraryAgents<
  TData = Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListFavoriteLibraryAgents<
  TData = Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Favorite Library Agents
 */

export function useGetV2ListFavoriteLibraryAgents<
  TData = Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListFavoriteLibraryAgentsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Favorite Library Agents
 */
export const prefetchGetV2ListFavoriteLibraryAgentsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListFavoriteLibraryAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFavoriteLibraryAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListFavoriteLibraryAgentsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetAgentByStoreIdResponse200 = {
  data: LibraryAgent | null;
  status: 200;
};

export type getV2GetAgentByStoreIdResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetAgentByStoreIdResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetAgentByStoreIdResponseSuccess =
  getV2GetAgentByStoreIdResponse200 & {
    headers: Headers;
  };
export type getV2GetAgentByStoreIdResponseError = (
  | getV2GetAgentByStoreIdResponse401
  | getV2GetAgentByStoreIdResponse422
) & {
  headers: Headers;
};

export type getV2GetAgentByStoreIdResponse =
  | getV2GetAgentByStoreIdResponseSuccess
  | getV2GetAgentByStoreIdResponseError;

export const getGetV2GetAgentByStoreIdUrl = (storeListingVersionId: string) => {
  return `/api/library/agents/marketplace/${storeListingVersionId}`;
};

/**
 * Get Library Agent from Store Listing Version ID.
 * @summary Get Agent By Store ID
 */
export const getV2GetAgentByStoreId = async (
  storeListingVersionId: string,
  options?: RequestInit,
): Promise<getV2GetAgentByStoreIdResponse> => {
  return customMutator<getV2GetAgentByStoreIdResponse>(
    getGetV2GetAgentByStoreIdUrl(storeListingVersionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetAgentByStoreIdQueryKey = (
  storeListingVersionId: string,
) => {
  return [`/api/library/agents/marketplace/${storeListingVersionId}`] as const;
};

export const getGetV2GetAgentByStoreIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetAgentByStoreIdQueryKey(storeListingVersionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetAgentByStoreId>>
  > = ({ signal }) =>
    getV2GetAgentByStoreId(storeListingVersionId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      storeListingVersionId !== null && storeListingVersionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetAgentByStoreIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetAgentByStoreId>>
>;
export type GetV2GetAgentByStoreIdQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetAgentByStoreId<
  TData = Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAgentByStoreId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAgentByStoreId<
  TData = Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAgentByStoreId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAgentByStoreId<
  TData = Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Agent By Store ID
 */

export function useGetV2GetAgentByStoreId<
  TData = Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetAgentByStoreIdQueryOptions(
    storeListingVersionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Agent By Store ID
 */
export const prefetchGetV2GetAgentByStoreIdQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByStoreId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetAgentByStoreIdQueryOptions(
    storeListingVersionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type deleteV2DeleteLibraryAgentResponse200 = {
  data: unknown;
  status: 200;
};

export type deleteV2DeleteLibraryAgentResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV2DeleteLibraryAgentResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV2DeleteLibraryAgentResponseSuccess =
  deleteV2DeleteLibraryAgentResponse200 & {
    headers: Headers;
  };
export type deleteV2DeleteLibraryAgentResponseError = (
  | deleteV2DeleteLibraryAgentResponse401
  | deleteV2DeleteLibraryAgentResponse422
) & {
  headers: Headers;
};

export type deleteV2DeleteLibraryAgentResponse =
  | deleteV2DeleteLibraryAgentResponseSuccess
  | deleteV2DeleteLibraryAgentResponseError;

export const getDeleteV2DeleteLibraryAgentUrl = (libraryAgentId: string) => {
  return `/api/library/agents/${libraryAgentId}`;
};

/**
 * Soft-delete the specified library agent.
 * @summary Delete Library Agent
 */
export const deleteV2DeleteLibraryAgent = async (
  libraryAgentId: string,
  options?: RequestInit,
): Promise<deleteV2DeleteLibraryAgentResponse> => {
  return customMutator<deleteV2DeleteLibraryAgentResponse>(
    getDeleteV2DeleteLibraryAgentUrl(libraryAgentId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV2DeleteLibraryAgentMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV2DeleteLibraryAgent>>,
    TError,
    { libraryAgentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV2DeleteLibraryAgent>>,
  TError,
  { libraryAgentId: string },
  TContext
> => {
  const mutationKey = ["deleteV2DeleteLibraryAgent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV2DeleteLibraryAgent>>,
    { libraryAgentId: string }
  > = (props) => {
    const { libraryAgentId } = props ?? {};

    return deleteV2DeleteLibraryAgent(libraryAgentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV2DeleteLibraryAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV2DeleteLibraryAgent>>
>;

export type DeleteV2DeleteLibraryAgentMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Delete Library Agent
 */
export const useDeleteV2DeleteLibraryAgent = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV2DeleteLibraryAgent>>,
      TError,
      { libraryAgentId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV2DeleteLibraryAgent>>,
  TError,
  { libraryAgentId: string },
  TContext
> => {
  return useMutation(
    getDeleteV2DeleteLibraryAgentMutationOptions(options),
    queryClient,
  );
};
export type getV2GetLibraryAgentResponse200 = {
  data: LibraryAgent;
  status: 200;
};

export type getV2GetLibraryAgentResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetLibraryAgentResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetLibraryAgentResponseSuccess =
  getV2GetLibraryAgentResponse200 & {
    headers: Headers;
  };
export type getV2GetLibraryAgentResponseError = (
  | getV2GetLibraryAgentResponse401
  | getV2GetLibraryAgentResponse422
) & {
  headers: Headers;
};

export type getV2GetLibraryAgentResponse =
  | getV2GetLibraryAgentResponseSuccess
  | getV2GetLibraryAgentResponseError;

export const getGetV2GetLibraryAgentUrl = (libraryAgentId: string) => {
  return `/api/library/agents/${libraryAgentId}`;
};

/**
 * @summary Get Library Agent
 */
export const getV2GetLibraryAgent = async (
  libraryAgentId: string,
  options?: RequestInit,
): Promise<getV2GetLibraryAgentResponse> => {
  return customMutator<getV2GetLibraryAgentResponse>(
    getGetV2GetLibraryAgentUrl(libraryAgentId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetLibraryAgentQueryKey = (libraryAgentId: string) => {
  return [`/api/library/agents/${libraryAgentId}`] as const;
};

export const getGetV2GetLibraryAgentQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetLibraryAgentQueryKey(libraryAgentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetLibraryAgent>>
  > = ({ signal }) =>
    getV2GetLibraryAgent(libraryAgentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: libraryAgentId !== null && libraryAgentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetLibraryAgentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetLibraryAgent>>
>;
export type GetV2GetLibraryAgentQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetLibraryAgent<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
          TError,
          Awaited<ReturnType<typeof getV2GetLibraryAgent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetLibraryAgent<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
          TError,
          Awaited<ReturnType<typeof getV2GetLibraryAgent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetLibraryAgent<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Library Agent
 */

export function useGetV2GetLibraryAgent<
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetLibraryAgentQueryOptions(
    libraryAgentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Library Agent
 */
export const prefetchGetV2GetLibraryAgentQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetLibraryAgent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetLibraryAgentQueryOptions(
    libraryAgentId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type patchV2UpdateLibraryAgentResponse200 = {
  data: LibraryAgent;
  status: 200;
};

export type patchV2UpdateLibraryAgentResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type patchV2UpdateLibraryAgentResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type patchV2UpdateLibraryAgentResponseSuccess =
  patchV2UpdateLibraryAgentResponse200 & {
    headers: Headers;
  };
export type patchV2UpdateLibraryAgentResponseError = (
  | patchV2UpdateLibraryAgentResponse401
  | patchV2UpdateLibraryAgentResponse422
) & {
  headers: Headers;
};

export type patchV2UpdateLibraryAgentResponse =
  | patchV2UpdateLibraryAgentResponseSuccess
  | patchV2UpdateLibraryAgentResponseError;

export const getPatchV2UpdateLibraryAgentUrl = (libraryAgentId: string) => {
  return `/api/library/agents/${libraryAgentId}`;
};

/**
 * Update the library agent with the given fields.
 * @summary Update Library Agent
 */
export const patchV2UpdateLibraryAgent = async (
  libraryAgentId: string,
  libraryAgentUpdateRequest: LibraryAgentUpdateRequest,
  options?: RequestInit,
): Promise<patchV2UpdateLibraryAgentResponse> => {
  return customMutator<patchV2UpdateLibraryAgentResponse>(
    getPatchV2UpdateLibraryAgentUrl(libraryAgentId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(libraryAgentUpdateRequest),
    },
  );
};

export const getPatchV2UpdateLibraryAgentMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV2UpdateLibraryAgent>>,
    TError,
    { libraryAgentId: string; data: LibraryAgentUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV2UpdateLibraryAgent>>,
  TError,
  { libraryAgentId: string; data: LibraryAgentUpdateRequest },
  TContext
> => {
  const mutationKey = ["patchV2UpdateLibraryAgent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV2UpdateLibraryAgent>>,
    { libraryAgentId: string; data: LibraryAgentUpdateRequest }
  > = (props) => {
    const { libraryAgentId, data } = props ?? {};

    return patchV2UpdateLibraryAgent(libraryAgentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV2UpdateLibraryAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV2UpdateLibraryAgent>>
>;
export type PatchV2UpdateLibraryAgentMutationBody = LibraryAgentUpdateRequest;
export type PatchV2UpdateLibraryAgentMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update Library Agent
 */
export const usePatchV2UpdateLibraryAgent = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV2UpdateLibraryAgent>>,
      TError,
      { libraryAgentId: string; data: LibraryAgentUpdateRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV2UpdateLibraryAgent>>,
  TError,
  { libraryAgentId: string; data: LibraryAgentUpdateRequest },
  TContext
> => {
  return useMutation(
    getPatchV2UpdateLibraryAgentMutationOptions(options),
    queryClient,
  );
};
export type postV2ForkLibraryAgentResponse200 = {
  data: LibraryAgent;
  status: 200;
};

export type postV2ForkLibraryAgentResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2ForkLibraryAgentResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2ForkLibraryAgentResponseSuccess =
  postV2ForkLibraryAgentResponse200 & {
    headers: Headers;
  };
export type postV2ForkLibraryAgentResponseError = (
  | postV2ForkLibraryAgentResponse401
  | postV2ForkLibraryAgentResponse422
) & {
  headers: Headers;
};

export type postV2ForkLibraryAgentResponse =
  | postV2ForkLibraryAgentResponseSuccess
  | postV2ForkLibraryAgentResponseError;

export const getPostV2ForkLibraryAgentUrl = (libraryAgentId: string) => {
  return `/api/library/agents/${libraryAgentId}/fork`;
};

/**
 * @summary Fork Library Agent
 */
export const postV2ForkLibraryAgent = async (
  libraryAgentId: string,
  options?: RequestInit,
): Promise<postV2ForkLibraryAgentResponse> => {
  return customMutator<postV2ForkLibraryAgentResponse>(
    getPostV2ForkLibraryAgentUrl(libraryAgentId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2ForkLibraryAgentMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2ForkLibraryAgent>>,
    TError,
    { libraryAgentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2ForkLibraryAgent>>,
  TError,
  { libraryAgentId: string },
  TContext
> => {
  const mutationKey = ["postV2ForkLibraryAgent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2ForkLibraryAgent>>,
    { libraryAgentId: string }
  > = (props) => {
    const { libraryAgentId } = props ?? {};

    return postV2ForkLibraryAgent(libraryAgentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2ForkLibraryAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2ForkLibraryAgent>>
>;

export type PostV2ForkLibraryAgentMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Fork Library Agent
 */
export const usePostV2ForkLibraryAgent = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2ForkLibraryAgent>>,
      TError,
      { libraryAgentId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2ForkLibraryAgent>>,
  TError,
  { libraryAgentId: string },
  TContext
> => {
  return useMutation(
    getPostV2ForkLibraryAgentMutationOptions(options),
    queryClient,
  );
};
export type getV2ListTriggerAgentsResponse200 = {
  data: LibraryAgent[];
  status: 200;
};

export type getV2ListTriggerAgentsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListTriggerAgentsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListTriggerAgentsResponseSuccess =
  getV2ListTriggerAgentsResponse200 & {
    headers: Headers;
  };
export type getV2ListTriggerAgentsResponseError = (
  | getV2ListTriggerAgentsResponse401
  | getV2ListTriggerAgentsResponse422
) & {
  headers: Headers;
};

export type getV2ListTriggerAgentsResponse =
  | getV2ListTriggerAgentsResponseSuccess
  | getV2ListTriggerAgentsResponseError;

export const getGetV2ListTriggerAgentsUrl = (libraryAgentId: string) => {
  return `/api/library/agents/${libraryAgentId}/triggers`;
};

/**
 * List trigger agents linked to the given parent agent.
 * @summary List Trigger Agents
 */
export const getV2ListTriggerAgents = async (
  libraryAgentId: string,
  options?: RequestInit,
): Promise<getV2ListTriggerAgentsResponse> => {
  return customMutator<getV2ListTriggerAgentsResponse>(
    getGetV2ListTriggerAgentsUrl(libraryAgentId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListTriggerAgentsQueryKey = (libraryAgentId: string) => {
  return [`/api/library/agents/${libraryAgentId}/triggers`] as const;
};

export const getGetV2ListTriggerAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListTriggerAgentsQueryKey(libraryAgentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListTriggerAgents>>
  > = ({ signal }) =>
    getV2ListTriggerAgents(libraryAgentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: libraryAgentId !== null && libraryAgentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListTriggerAgentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListTriggerAgents>>
>;
export type GetV2ListTriggerAgentsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListTriggerAgents<
  TData = Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListTriggerAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListTriggerAgents<
  TData = Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListTriggerAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListTriggerAgents<
  TData = Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Trigger Agents
 */

export function useGetV2ListTriggerAgents<
  TData = Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListTriggerAgentsQueryOptions(
    libraryAgentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Trigger Agents
 */
export const prefetchGetV2ListTriggerAgentsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  libraryAgentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTriggerAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListTriggerAgentsQueryOptions(
    libraryAgentId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
